<div class="question-area multilevel-menu">
  <form [formGroup]="form">
    <h3-powerlist-menu
      [menuItems]="menuItems"
      [disabled]="disabled$ | async"
      formControlName="input"
    ></h3-powerlist-menu>
  </form>
</div>
